import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import AppButton from '../button/Button';
import ContentHeader from '../content-header/ContentHeader';
import PoshInputs from '../Forms/InputForms/Inputs';
import swal from 'sweetalert';
import apiResponseGenerator from '@app/utils/apiResponseGenerator';

function UpdateUserRole() {
  const {state} = useLocation();
  const [roleName, setroleName] = useState('');
  const [disable, setdisable] = useState(true);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [savedPermissions, setSavedPermissions] = useState<any>([]);

  useEffect(() => {
    getByIdUserRoles(state);
  }, []);

  const getByIdUserRoles = async (id: any) => {
    const result = await apiResponseGenerator({
      dispatchFunction: dispatch,
      method: "get",
      url: `roles/get/${id}`
    });
    if (result) {
      const response = result.data;
      response.map((element: any) => {
        setroleName(element.roleName);
        setSavedPermissions(element.permission);
      });
    }
  };

  const handleChange = (
    id: number,
    RowIndex: number,
    title: string,
    event: any
  ) => {
    const {checked, name} = event;

    if (id === +savedPermissions[RowIndex].id) {
      setdisable(false);
      const newArr = [...savedPermissions];
      savedPermissions.forEach((data: any) => {
        const allKeys: any = Object.keys(data);

        if (allKeys.includes(name) && data.title === title) {
          if (
            allKeys.find((element: any) => element === 'view') === name &&
            data.title === title
          ) {
            newArr[RowIndex].view = checked;
          }
          if (
            allKeys.find((element: any) => element === 'edit') === name &&
            data.title === title
          ) {
            newArr[RowIndex].edit = checked;
          }
          if (
            allKeys.find((element: any) => element === 'delete') === name &&
            data.title === title
          ) {
            newArr[RowIndex].delete = checked;
          }
        }
      });
      setSavedPermissions(newArr);
    }
  };

  const UpdatePermissionsRole = async () => {
    if (!disable) {
      await swal({
        title: 'Are you sure ?',
        text: 'You want to update user role ?',
        icon: 'warning',
        buttons: [true, true],
        dangerMode: true,
        closeOnClickOutside: false,
      }).then(async (res) => {
        if (res) {
          const data = {
            roleName: roleName,
            permissions: savedPermissions
          };
          // dispatch,
          // 'post',
          // `roles/update/${state}`,
          // data

          const add_api_response = await apiResponseGenerator({
            dispatchFunction: dispatch,
            method: 'post',
            url: `roles/update/${state}`,
            body: data
          });

          if (add_api_response) {
            swal(`UserRole update successfully.`, {
              icon: 'success'
            });
            navigate('/admin/user-and-role/userroles');
          }
        }
      });
    }
  };

  return (
    <div>
      <ContentHeader title="Update User Role" />
      <section className=" bg-white p-4 rounded m-3 mb-3">
        <div className="table-responsive-xxl">
          <div
            className="inputWrapper p-0 col-sm-4 col-12"
            style={{marginLeft: '-7px'}}
          >
            <PoshInputs
              title="Role Name"
              type={'text'}
              value={roleName}
              onChange={(e: any) => setroleName(e.target.value)}
              readOnly={true}
            />
          </div>

          <table className="table">
            <thead className="thead-light">
              <tr>
                <th scope="col">Title</th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col">View</th>
                <th scope="col">Edit</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {savedPermissions?.map((items: any, index: number) => {
                return (
                  <tr key={index}>
                    <td scope="row">{items.title}</td>
                    <td></td>
                    <td></td>
                    <td>
                      <label className="container d-flex justify-content-center">
                        <input
                          name="view"
                          onChange={(e: any) =>
                            handleChange(items.id, index, items.title, e.target)
                          }
                          defaultChecked={items.view}
                          type="checkbox"
                        />
                        <div className="checkmark" />
                      </label>
                    </td>

                    <td>
                      <label className="container d-flex justify-content-center">
                        <input
                          name="edit"
                          onChange={(e: any) =>
                            handleChange(items.id, index, items.title, e.target)
                          }
                          defaultChecked={items.edit}
                          type="checkbox"
                        />
                        <div className="checkmark" />
                      </label>
                    </td>

                    <td>
                      <label className="container d-flex justify-content-center">
                        <input
                          name="delete"
                          onChange={(e: any) =>
                            handleChange(items.id, index, items.title, e.target)
                          }
                          defaultChecked={items.delete}
                          type="checkbox"
                        />
                        <div className="checkmark" />
                      </label>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="d-flex justify-content-end">
            <AppButton
              children={'Cancel'}
              className="btn btn-light mr-3"
              onClick={() => {
                navigate('/admin/user-and-role/userroles');
              }}
            />
            <AppButton
              children={'Update'}
              disabled={disable}
              onClick={() => {
                UpdatePermissionsRole();
              }}
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default UpdateUserRole;
